package org.teddapp.project.sync

import org.teddapp.project.core.RemoteCore
import org.teddapp.project.server.ServerSession

/** Le noyau distant, servi par teddApp : `/v1/events` pour écrire, `/v1/core/snapshot` pour lire. */
class ServerRemoteCore(private val session: ServerSession) : RemoteCore {
    override suspend fun snapshotJson(): String = session.authed { api, access -> api.coreSnapshot(access) }

    override suspend fun publish(envelopes: List<String>) {
        journalBatches(envelopes).forEach { batch -> session.authed { api, access -> api.publishEvents(access, batch) } }
    }
}
